export default {
  MANUFACTURING_STARTED: 'MANUFACTURING_STARTED',
  COMPLETED: 'COMPLETED',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED',
} as const
